import React from 'react';
import '../CSS/App.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {connect} from "react-redux";
import {Incidents, Systems} from "../Redux/ContentfulContentGrabber";
import Moment from 'moment';
import ShowMoreText from 'react-show-more-text';
import {MuiThemeProvider} from "material-ui";
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import ReactMarkdown from 'react-markdown';

//This component controls the alerts that appear above the above the list of system statuses
class AlertComponent extends React.Component {
    constructor() {
        super();
    }

    componentWillMount() {
        //Gathers all the contentful data from Redux
        this.props.fetchSystemData();
        this.props.fetchIncidentsData();
    }

    //Scrolls to the top of an alert card when the user minimizes the "Read More" button
    static handleScrollToElement(i) {
        let offsets = document.getElementById(i).getBoundingClientRect();
        let top = offsets.top;
        window.scrollBy(0, top - 80);
    }

    getSystemRowsFromContentful() {
        let listOfAllSystemStatuses = [];
        for (let i = 0; i < this.props.systems.items.length; i++) {
            listOfAllSystemStatuses.push(this.props.systems.items[i].fields.name.toString());
        }
        return listOfAllSystemStatuses;
    }

    //Sorts statuses by Outages at the top, Alerts second and Maintenance third
    static sortStatusListByStatusLevel(unorderedStatus) {
        return unorderedStatus.sort(function (a, b) {
            return a[2] < b[2] ? 1 : -1;
        });
    }

    getIncidentList() {
        let unorderedSystemsListFromContentful = this.getSystemRowsFromContentful();
        let orderedSystemsListFromContentful = AlertComponent.sortStatusListByStatusLevel(unorderedSystemsListFromContentful);
        return this.createIncidentListArrays(orderedSystemsListFromContentful);
    }

    createIncidentListArrays(orderedSystemsListFromContentful) {
        let incidentList = [];
        for (let i of orderedSystemsListFromContentful) {
            //initializes incidents for each system
            let incidentsForEachSystem = [];
            incidentList.push(incidentsForEachSystem);
        }

        for (let i = 0; i < this.props.incidents.items.length; i++) {
            for (let x = 0; x < orderedSystemsListFromContentful.length; x++) {
                if (orderedSystemsListFromContentful[x].toString() === this.props.incidents.items[i].fields.system.fields.name.toString()) {
                    incidentList[x].push(this.props.incidents.items[i]);
                }
            }
        }
        return incidentList;
    }

    getAlerts(allIncidents) {
        Moment.locale('en');

        let alert = [];
        let sortedAlert;
        let sortedCreateAlert = [];

        for (let incidentsPerSystem of allIncidents) {
            for (let incident of incidentsPerSystem) {
                if (!AlertComponent.isIncidentResolvedYet(incident)){
                    alert.push(incident);
                }
            }
        }
        sortedAlert = AlertComponent.sortAlertsByOpenDate(alert);
        for (let i = 0; i < Math.min(sortedAlert.length, 20); i++) {
            let systemName = sortedAlert[i].fields.system.fields.name.toString();
            let incidentDescription = sortedAlert[i].fields.incidentDescription.toString();
            let incidentStatus = sortedAlert[i].fields.status.fields.statusName.toString();

            //If a estimated resolved date is not provided by contentful, default to N/A without a time
            let estimateResolveDate = "N/A";
            let estimatedResolvedTime = "";
            if (typeof(sortedAlert[i].sys.updatedAt) !== "undefined") {
                estimateResolveDate = Moment(sortedAlert[i].sys.updatedAt).format('MMM D, YYYY');
                estimatedResolvedTime = "- " + Moment(sortedAlert[i].sys.updatedAt).format('hh:mm A') + " EST";
            }
            if (typeof(sortedAlert[i].fields.resolveDate) !== "undefined") {
                estimateResolveDate = Moment(sortedAlert[i].fields.resolveDate).format('MMM D, YYYY');
                estimatedResolvedTime = "- " + Moment(sortedAlert[i].fields.resolveDate).format('hh:mm A') + " EST";
            }

            sortedCreateAlert.push(this.createAlert(systemName, incidentStatus, incidentDescription, estimateResolveDate, estimatedResolvedTime, i));
        }
        return sortedCreateAlert;
    }

    //This function puts the alerts that are the oldest at the top of the alerts list
    static sortAlertsByOpenDate(alerts) {
        return alerts.sort(function (a, b) {
            return a.fields.openDate > b.fields.openDate ? 1 : -1;
        });
    }

    //This checks if the incident is resolved, if it is resolved then it should not be an alert
    static isIncidentResolvedYet(incident) {
        return incident.fields.resolved !== false;
    }

    createAlert(systemName, incidentStatus, incidentDescription, resolveDate, resolveTime, i) {


        //This portion sets the CSS color based on the category of the alert
        let backgroundColor;
        if (incidentStatus === "Maintenance") {
            backgroundColor = "#8e9ddd";
        } else if (incidentStatus === "Currently not available") {
            backgroundColor = "#d98f8a";
        }
        else if (incidentStatus === "Alert") {
            backgroundColor = "#edb688";
        }

        return (
            <div className={"atlassianAlert"} id={i} style={{borderColor: backgroundColor}}>
                <div className={"atlassianHeader"} style={{backgroundColor: backgroundColor}}>
                    <div className={"atlassianHeaderText"}>
                        {systemName} - {incidentStatus}
                    </div>
                </div>
                <div className={"atlassianBody"}>
                    <ShowMoreText
                        lines={3}
                        more={<div className={"showMoreButton"}><b>Show more</b></div>}
                        less={<div className={"showMoreButton"} onClick={() => AlertComponent.handleScrollToElement(i)}><b>Show
                            less</b></div>}
                        anchorClass=''>
                        <ReactMarkdown className={"fontRegularMedium align_center"} source={incidentDescription}/>
                    </ShowMoreText>
                    <div className={"dateText"}>
                        Estimated Resolution: {resolveDate} {resolveTime}
                    </div>
                </div>
            </div>
        );
    }

    //This checks to see if contentful content has been returned yet, if false then it should be still waiting for content
    isContentfulContentAvailableYet() {
        return !Array.isArray(this.props.systems) && !Array.isArray(this.props.incidents);
    }

    render() {
        if (this.isContentfulContentAvailableYet()) {
            let incidents = this.getIncidentList();
            let alerts = this.getAlerts(incidents);
            return (
                //React CSS Transition Group causes the component to fade in
                <ReactCSSTransitionGroup
                    transitionName="example"
                    transitionAppear={true}
                    transitionAppearTimeout={50000}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <MuiThemeProvider muiTheme={getMuiTheme()}>
                        <div className={"alertComponent"}>
                            {alerts}
                        </div>
                    </MuiThemeProvider>
                </ReactCSSTransitionGroup>
            );
        }
        return (null);
    }
}

//Redux, gathers all Contentful Data
const mapStateToProps = (state) => {
    return {
        systems: state.systems,
        incidents: state.incidents,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading
    };
};

//Redux, gathers all Contentful Data
const mapDispatchToProps = (dispatch) => {
    return {
        fetchSystemData: () => dispatch(Systems()),
        fetchIncidentsData: () => dispatch(Incidents())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertComponent);



// WEBPACK FOOTER //
// ./src/Components/AlertComponent.js